import React, { useEffect, useState } from "react";
import { Modal } from "@mui/material";
import Styles from "./ViewModalReceived.module.css";
import { Close } from "@mui/icons-material";
import { toast } from "react-toastify";
import Loader from "../../../../commons/Loader/Loader";
import { ReactComponent as SquareIcon } from "../../../../assets/images/view.svg";
import { updateStatusConnection } from "../../../../Services/ApiCalling/banking";
import ViewInjectionModal from "../ViewInjectionModal/ViewInjectionModal";
import ViewDrawalModal from "../ViewDrawalModal/ViewDrawalModal";
import ConnectionAcceptModal from "../../../../commons/PopupModal/BankingPopup/ConnectionAcceptModal/ConnectionAcceptModal";
import PreviewModal from "../../../../commons/PreviewModal/PreviewModal";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchMatchmakingResults,
  fetchAllBankingListings,
} from "../../../../Redux/Slices/bankingSlice";
import { getDocumentUrlByLedgerId } from "../../../../Services/ApiCalling/banking";
import SocketService from "../../../../commons/Socket/SocketService";

const ViewModalReceived = ({
  open,
  handleClose,
  data,
  refreshConnectionRequests,
  requestsLoading,
  onConnectionAccepted,
  initiatorListing,
}) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [showMore, setShowMore] = useState(false);

  const [injectionModalOpen, setInjectionModalOpen] = useState(false);
  const [injectionData, setInjectionData] = useState([]);

  const [drawalModalOpen, setDrawalModalOpen] = useState(false);
  const [drawalData, setDrawalData] = useState([]);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [confirmAction, setConfirmAction] = useState(null);
  const [previewModal, setPreviewModal] = useState(false);
  const [previewFileUrl, setPreviewFileUrl] = useState(null);
  const [currentDocumentId, setCurrentDocumentId] = useState(null);

  const myListingData =
    data?.source === "PLACED"
      ? data?.bankingListing
      : data?.againstBankingListing;

  const counterpartyListingData =
    data?.source === "PLACED"
      ? data?.againstBankingListing
      : data?.bankingListing;

  const formatDateTime = (input) => {
    const date = new Date(input);
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const day = String(date.getDate()).padStart(2, "0");
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${day}-${month}-${year} ${hours}:${minutes}`;
  };

  const handleOpenInjectionModal = (slots) => {
    setInjectionData(slots || []);
    setInjectionModalOpen(true);
  };
  const handleOpenDrawalModal = (slots) => {
    setDrawalData(slots || []);
    setDrawalModalOpen(true);
  };

  const handleViewTermsDocument = async (termsDocumentId) => {
    if (!termsDocumentId || termsDocumentId === 0) {
      console.warn("No terms document ID available");
      return;
    }

    try {
      const response = await getDocumentUrlByLedgerId(termsDocumentId);
      const url = response?.data || response;
      if (url) {
        setPreviewFileUrl(url);
        setCurrentDocumentId(termsDocumentId);
        setPreviewModal(true);
      } else {
        console.error("No URL found for terms document");
      }
    } catch (error) {
      console.error("Error viewing terms document:", error);
    }
  };

  useEffect(() => {
    if (!requestsLoading && isLoading) {
      setIsLoading(false);
      handleClose();
    }
  }, [requestsLoading, isLoading, handleClose]);

  const handleChatSetup = (fromName, toName, direct) => {
    const socket = SocketService.getSocket();
    let chatId;

    if (fromName === initiatorListing) {
      chatId = `${fromName?.split("_")?.[0]}_${toName?.split("_")?.[0]}`;
    } else {
      chatId = `${toName?.split("_")?.[0]}_${fromName?.split("_")?.[0]}`;
    }
    socket.emit("create-room", {
      chatId,
      fromUsername: fromName,
      toUsername: toName,
    });
    socket.emit("join-room", { chatId, username: fromName });
  };

  const handleConfirmStatusUpdate = async () => {
    let fromBanking = data?.bankingListing?.name;
    let toBanking = data?.againstBankingListing?.name;

    setConfirmModalOpen(false);
    setIsLoading(true);
    try {
      let res = await updateStatusConnection(
        data?.id,
        confirmAction === "ACCEPTED" ? 1 : 0,
      );
      if (res?.data?.code === 200) {
        handleChatSetup(fromBanking, toBanking);

        if (confirmAction === "ACCEPTED") {
          const listingId = data?.bankingListing?.id;

          if (listingId) {
            await dispatch(fetchMatchmakingResults({ id: listingId }));
          }

          await dispatch(fetchAllBankingListings());

          if (typeof onConnectionAccepted === "function") {
            onConnectionAccepted(data);
          }

          if (typeof refreshConnectionRequests === "function") {
            await refreshConnectionRequests();
          }


          setTimeout(() => {
            setIsLoading(false);
            handleClose();
          }, 300);
        } else {
          if (typeof refreshConnectionRequests === "function") {
            await refreshConnectionRequests();
          }


          setTimeout(() => {
            setIsLoading(false);
            handleClose();
          }, 300);
        }
      }
    } catch (error) {
      setIsLoading(false);
      toast.error(error?.response?.data?.message || "Something went wrong");
    }
  };

  function formatEndTime(timeStr) {
    if (timeStr === "23:59") return "24:00";
    return timeStr;
  }

  const connectLoading = useSelector(
    (state) => state.notificationSlice?.loading || false,
  );

  return (
    <>
      <ViewInjectionModal
        open={injectionModalOpen}
        handleClose={() => setInjectionModalOpen(false)}
        data={injectionData}
      />

      <ViewDrawalModal
        open={drawalModalOpen}
        handleClose={() => setDrawalModalOpen(false)}
        data={drawalData}
      />

      <ConnectionAcceptModal
        open={confirmModalOpen}
        handleClose={() => setConfirmModalOpen(false)}
        content={confirmAction === "ACCEPTED" ? "Accept" : "Decline"}
        onConfirm={handleConfirmStatusUpdate}
        actionType={confirmAction}
        insideViewModal={true}
        loading={connectLoading}
      />

      <PreviewModal
        open={previewModal}
        onClose={() => {
          setPreviewModal(false);
          setPreviewFileUrl(null);
          setCurrentDocumentId(null);
        }}
        fileUrl={previewFileUrl}
        documentId={currentDocumentId}
      />

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <div className={`popupModal ${Styles.createEditModalCont}`}>
          <div
            className={`display_flex_row modalHeading ${Styles.modalHeading}`}
          >
            <div className={Styles.headingText}>Connection Request</div>
            <Close
              style={{ fontSize: 24, color: "#777777", cursor: "pointer" }}
              onClick={handleClose}
            />
          </div>

          <div className={`display_flex_row_center ${Styles.tableViewHeading}`}>
            <div
              className={`display_flex_row_center ${Styles.tableViewContentCont}`}
            >
              <div className={`display_flex_row ${Styles.tableArea}`}>
                <div>Category</div>
                <div>My Listing</div>
                <div>Counterparty Listing</div>
              </div>
              {data && (
                <div
                  className={`display_flex_row_center ${Styles.viewTableContent}`}
                >
                  <div
                    className={`display_flex_row ${Styles.tableViewContent}`}
                  >
                    <div>Name</div>
                    <div className={Styles.bankingHead}>
                      {myListingData?.name || "—"}
                    </div>
                    <div className={Styles.bankingHead2}>
                      {counterpartyListingData?.name || "—"}
                    </div>
                  </div>
                  <div
                    className={`display_flex_row ${Styles.tableViewContent}`}
                  >
                    <div>Injection Quantity (MW)</div>
                    <div className={Styles.myQty}>
                      {" "}
                      {myListingData?.bankingSlotInjects?.[0] ? (
                        <div>
                          {myListingData.bankingSlotInjects[0].requiredQty}{" "}
                        </div>
                      ) : (
                        "—"
                      )}
                    </div>
                    <div className={Styles.otherHead}>
                      {" "}
                      {counterpartyListingData?.bankingSlotInjects?.[0] ? (
                        <div>
                          {
                            counterpartyListingData.bankingSlotInjects[0]
                              .requiredQty
                          }{" "}
                        </div>
                      ) : (
                        "—"
                      )}
                    </div>
                  </div>

                  <div
                    className={`display_flex_row ${Styles.tableViewContent}`}
                  >
                    <div>Drawal Quantity (MW)</div>
                    <div className={Styles.myQty}>
                      {" "}
                      {myListingData?.bankingSlotDrawls?.[0] ? (
                        <div>
                          {myListingData.bankingSlotDrawls[0].requiredQty}{" "}
                        </div>
                      ) : (
                        "—"
                      )}
                    </div>
                    <div className={Styles.otherHead}>
                      {" "}
                      {counterpartyListingData?.bankingSlotDrawls?.[0] ? (
                        <div>
                          {
                            counterpartyListingData.bankingSlotDrawls[0]
                              .requiredQty
                          }{" "}
                        </div>
                      ) : (
                        "—"
                      )}
                    </div>
                  </div>
                  <div
                    className={`display_flex_row ${Styles.tableViewContent}`}
                  >
                    <div>Banking Factor (%)</div>
                    <div className={Styles.myQty}>
                      {myListingData?.bankingFactor || "—"}
                    </div>
                    <div className={Styles.otherHead}>
                      {counterpartyListingData?.bankingFactor || "—"}
                    </div>
                  </div>
                  <div
                    className={`display_flex_row ${Styles.tableViewContent}`}
                  >
                    <div>Settlement Rate (₹/kWh)</div>
                    <div className={Styles.myQty}>
                      {myListingData?.settlementRate || "—"}
                    </div>
                    <div className={Styles.otherHead}>
                      {counterpartyListingData?.settlementRate || "—"}
                    </div>
                  </div>

                  <div className={` ${Styles.tableViewContent}`}>
                    <div>Injection Date and Time Range</div>

                    <div className={`${Styles.injectDrawalSection}`}>
                      {myListingData?.bankingSlotInjects?.[0] ? (
                        <div>
                          {myListingData.bankingSlotInjects[0].dateStartAt} to{" "}
                          {myListingData.bankingSlotInjects[0].dateEndAt}
                          <br />
                          {
                            myListingData.bankingSlotInjects[0].slotStartAt
                          } to{" "}
                          {formatEndTime(
                            myListingData.bankingSlotInjects[0].slotEndAt,
                          )}
                        </div>
                      ) : (
                        "—"
                      )}
                      <span
                        className={Styles.spanIcon}
                        onClick={() =>
                          handleOpenInjectionModal(
                            myListingData.bankingSlotInjects,
                          )
                        }
                      >
                        <SquareIcon style={{ width: "20px", height: "20px" }} />
                      </span>
                    </div>

                    <div className={`${Styles.injectDrawalSectionCounter}`}>
                      {counterpartyListingData?.bankingSlotInjects?.[0] ? (
                        <div>
                          {
                            counterpartyListingData.bankingSlotInjects[0]
                              .dateStartAt
                          }{" "}
                          to{" "}
                          {
                            counterpartyListingData.bankingSlotInjects[0]
                              .dateEndAt
                          }
                          <br />
                          {
                            counterpartyListingData.bankingSlotInjects[0]
                              .slotStartAt
                          }{" "}
                          to{" "}
                          {formatEndTime(
                            counterpartyListingData.bankingSlotInjects[0]
                              .slotEndAt,
                          )}
                        </div>
                      ) : (
                        "—"
                      )}
                      <span>
                        <span
                          className={Styles.spanIconCounter}
                          onClick={() =>
                            handleOpenInjectionModal(
                              counterpartyListingData.bankingSlotInjects,
                            )
                          }
                        >
                          <SquareIcon
                            style={{
                              width: "20px",
                              height: "20px",
                              cursor: "pointer",
                            }}
                          />
                        </span>
                      </span>
                    </div>
                  </div>

                  <div
                    className={`display_flex_row ${Styles.tableViewContent}`}
                  >
                    <div>Drawal Date and Time Range</div>

                    <div className={`${Styles.injectDrawalSection}`}>
                      {myListingData?.bankingSlotDrawls?.[0] ? (
                        <div>
                          {myListingData.bankingSlotDrawls[0].dateStartAt} to{" "}
                          {myListingData.bankingSlotDrawls[0].dateEndAt}
                          <br />
                          {
                            myListingData.bankingSlotDrawls[0].slotStartAt
                          } to{" "}
                          {formatEndTime(
                            myListingData.bankingSlotDrawls[0].slotEndAt,
                          )}
                        </div>
                      ) : (
                        "—"
                      )}
                      <span
                        className={Styles.spanIcon}
                        onClick={() =>
                          handleOpenDrawalModal(myListingData.bankingSlotDrawls)
                        }
                      >
                        <SquareIcon style={{ width: "20px", height: "20px" }} />
                      </span>
                    </div>

                    <div className={`${Styles.injectDrawalSectionCounter}`}>
                      {counterpartyListingData?.bankingSlotDrawls?.[0] ? (
                        <div>
                          {
                            counterpartyListingData.bankingSlotDrawls[0]
                              .dateStartAt
                          }{" "}
                          to{" "}
                          {
                            counterpartyListingData.bankingSlotDrawls[0]
                              .dateEndAt
                          }{" "}
                          <br />
                          {
                            counterpartyListingData.bankingSlotDrawls[0]
                              .slotStartAt
                          }{" "}
                          to{" "}
                          {formatEndTime(
                            counterpartyListingData.bankingSlotDrawls[0]
                              .slotEndAt,
                          )}
                        </div>
                      ) : (
                        "—"
                      )}
                      <span
                        className={Styles.spanIconCounter2}
                        onClick={() =>
                          handleOpenDrawalModal(
                            counterpartyListingData.bankingSlotDrawls,
                          )
                        }
                      >
                        <SquareIcon style={{ width: "20px", height: "20px" }} />
                      </span>
                    </div>
                  </div>
                </div>
              )}
              {showMore && (
                <>
                  <div
                    className={`display_flex_row ${Styles.tableViewContent}`}
                  >
                    <div>Listing Expiry Date & Time</div>

                    <div style={{ width: "23%" }}>
                      {myListingData?.expiryAt || "—"}
                    </div>
                    <div
                      style={{
                        width: "23%",
                        textAlign: "left",
                      }}
                    >
                      {counterpartyListingData?.expiryAt || "—"}
                    </div>
                  </div>
                  <div
                    className={`display_flex_row ${Styles.tableViewContent}`}
                  >
                    <div>Terms Expiry Date & Time</div>

                    <div style={{ width: "23%" }}>
                      {formatDateTime(myListingData?.termsExpiryAt) || "—"}
                    </div>
                    <div
                      style={{
                        width: "23%",
                        textAlign: "left",
                      }}
                    >
                      {formatDateTime(counterpartyListingData?.termsExpiryAt) ||
                        "—"}
                    </div>
                  </div>
                  <div
                    className={`display_flex_row ${Styles.tableViewContent}`}
                  >
                    <div>Comments</div>

                    <div
                      style={{
                        width: "23%",
                        textAlign: "left",
                      }}
                      className={Styles.tableCommentsCell}
                    >
                      {myListingData?.comments || "—"}
                    </div>
                    <div
                      style={{
                        width: "23%",
                        textAlign: "left",
                      }}
                    >
                      {counterpartyListingData?.comments || "—"}
                    </div>
                  </div>
                  <div
                    className={`display_flex_row ${Styles.tableViewContent}`}
                  >
                    <div>Terms and Condition</div>

                    <div
                      style={{
                        width: "23%",
                        textAlign: "left",
                      }}
                      className={Styles.tableCommentsCell}
                    >
                      {myListingData?.termsDocumentId ? (
                        <span
                          style={{
                            color: "#f1935c",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            handleViewTermsDocument(
                              myListingData.termsDocumentId,
                            )
                          }
                        >
                          {/* {myListingData.termsDocumentId} */}
                          View T&C
                        </span>
                      ) : (
                        "—"
                      )}
                    </div>
                    <div
                      style={{
                        width: "23%",
                        textAlign: "left",
                      }}
                    >
                      {counterpartyListingData?.termsDocumentId ? (
                        <span
                          style={{
                            color: "#f1935c",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            handleViewTermsDocument(
                              counterpartyListingData.termsDocumentId,
                            )
                          }
                        >
                          {/* {counterpartyListingData.termsDocumentId} */}
                          View T&C
                        </span>
                      ) : (
                        "—"
                      )}
                    </div>
                  </div>
                </>
              )}
              <div
                className={`display_flex_row_center ${Styles.viewMoreBtn}`}
                onClick={() => setShowMore((prev) => !prev)}
              >
                {showMore ? "View Less" : "View More"}
              </div>
            </div>
          </div>
          {data?.status === "INITIATED" && data?.source !== "PLACED" && (
            <div
              className={`display_flex_row_center ${Styles.viewModalButtons}`}
            >
              <div
                className={Styles.cancelBankButton}
                onClick={handleClose}
                style={{ cursor: "pointer" }}
              >
                Cancel
              </div>
              <div
                className={`display_flex_row_center ${Styles.viewModalDeclines}`}
                // onClick={() => handleStatusUpdate(data?.id, "DECLINED")}
                onClick={() => {
                  setConfirmAction("DECLINED");
                  setConfirmModalOpen(true);
                }}
              >
                Decline
              </div>
              <div
                className={`display_flex_row_center ${Styles.viewModalAccept}`}
                // onClick={() => handleStatusUpdate(data?.id, "ACCEPTED")}
                onClick={() => {
                  setConfirmAction("ACCEPTED");
                  setConfirmModalOpen(true);
                }}
              >
                Accept
              </div>
            </div>
          )}

          {isLoading && (
            <div className={Styles.loaderOverlay}>
              <Loader />
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};

export default ViewModalReceived;
